<template>
  <div class="speaker">
    <img src="/static/img/icons/delete.svg" class="delete-icon" @click="deleteClubSpeaker(speaker.id)"/>
    <div class="rounded-photo-wrapper centered speaker-photo" @click="handleLoadSpeakerPhoto(speaker.id)" v-if="!speaker.photo">
          <span>Сменить фото</span>
    </div>
    <div v-else class="speaker-photo" v-bind:style="photoStyle" @click="deletePhoto">
      <div class="is-hidden delete-photo centered">
        <span>
          Удалить фото
        </span>
      </div>
    </div>
    <b-field>
        <b-input placeholder="Имя фамилия" v-model="speaker.name" @change="handleUpdateSpeaker"></b-input>
    </b-field>
    <b-field @change="handleUpdateSpeaker">
        <b-input type="textarea"
        @change="handleUpdateSpeaker"
        placeholder="Должность, какую компанию представляет"
        v-model="speaker.post"></b-input>
    </b-field>
    <input type="file" id='photo' @change='loadPhoto' hidden ref="loadPhotoButton"/>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'WebinarSpeaker',
  data () {
    return {
      updateTimer: 0
    }
  },
  props: {
    speaker: {
      type: Object,
      required: true
    }
  },
  methods: {
    ...mapActions(['updateClubSpeaker', 'loadClubSpeakerPhoto', 'deleteClubSpeakerPhoto', 'deleteClubSpeaker']),
    handleUpdateSpeaker () {
      this.updateClubSpeaker(this.speaker)
    },
    handleLoadSpeakerPhoto (id) {
      this.$refs.loadPhotoButton.click()
    },
    loadPhoto (e) {
      const reader = new FileReader()
      reader.readAsDataURL(e.target.files[0])
      const formData = new FormData()
      const file = e.target.files[0]
      formData.set('avatar', file)
      reader.onload = (e) => {
        this.speaker.photo = {
          base64photo: e.target.result,
          data: formData
        }
        this.updateClubSpeaker(this.speaker)
        this.$forceUpdate()
      }
    },
    deletePhoto () {
      this.speaker.photo = ''
      this.handleUpdateSpeaker()
    }
  },
  computed: {
    photoStyle () {
      return this.speaker.photo
      ? {background: !this.speaker.photo.base64photo ? `url(/upload/photos/${this.speaker.photo})` : `url(${this.speaker.photo.base64photo})`}
      : {background: ''}
    }
  }
}
</script>
<style scoped>
.rounded-photo-wrapper,
.speaker-photo {
  width: 160px;
  height: 160px;
  margin: 5px 0 15px;
  display: inline-flex;
}
.speaker-photo {
  border-radius: 50%;
  position: relative;
  cursor: pointer;
}
.speaker {
  border: 1px solid #eee;
  padding: 15px;
  text-align: center;
  position: relative;
}
.delete-icon {
  right: 10px;
  top: 10px;
  width: 25px;
}
.speaker-photo:hover .delete-photo {
  display: inherit !important;
  width: 100%;
}
.delete-photo span {
  background: white;
  padding: 5px 10px;
  border-radius: 15px;
}
</style>



// WEBPACK FOOTER //
// ClubSpeaker.vue?cb6486ea